import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Intro from "@/components/landing/Intro";
import Manifesto from "@/components/landing/Manifesto";
import Marquee from "@/components/landing/Marquee";
import ComingSoon from "@/components/landing/ComingSoon";
import Collection from "@/components/landing/Collection";
import Instagram from "@/components/landing/Instagram";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import { PaymentResult } from "@/components/landing/CheckoutPages";
import ShopPage from "@/components/landing/ShopPage";
import Dispatch from "@/components/landing/Dispatch";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.3,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      anchors: true,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="tabi-landing" className="grain min-h-screen bg-ink text-neutral-200 antialiased">
      <Nav />
      <main>
        <Hero />
        <Intro />
        <Manifesto />
        <Marquee />
        <Collection />
        <ComingSoon />
        <Instagram />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid rgba(197,160,89,0.35)",
            color: "#FAFAFA",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/dispatch" element={<Dispatch />} />
        <Route path="/payment/success" element={<PaymentResult variant="success" />} />
        <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
